const BannerBlue = require('./adtype_banner_blue.svg');
const BannerGray = require('./adtype_banner_gray.svg');
const InterBlue = require('./adtype_inter_blue.svg');
const InterGray = require('./adtype_inter_gray.svg');
const RewardedBlue = require('./adtype_rewarded_blue.svg');
const RewardedGray = require('./adtype_rewarded_gray.svg');
const MrecBlue = require('./adtype_mrec_blue.svg');
const MrecGray = require('./adtype_mrec_gray.svg');
const NativeBlue = require('./adtype_native_blue.svg');
const NativeGray = require('./adtype_native_gray.svg');
export { BannerBlue, BannerGray, InterBlue, InterGray, RewardedBlue, RewardedGray, MrecBlue, MrecGray, NativeBlue, NativeGray, };
//# sourceMappingURL=index.js.map